import React, { useRef } from "react";
import { Autocomplete } from "@edgelogistics/edge-ui/lib/components";
import { ExtraOptionsI, useSearchableData } from "./useSearchableData";
// @ts-expect-error
import { REACT_APP_BACKEND_COMMON_URL } from "@env";

interface TimeZoneSearchFieldProps {
  placeholder?: string;
  name?: string;
  nameProp?: string;
  multiselect?: boolean;
  selectedValue: Array<any> | any;
  onChangeValue: (name: string, value: any) => void;
  clear?: (name: string, value: any) => void;
  error?: string | boolean | any;
  testID?: string;
}

const getTimezoneSign = (number: number): string => (Math.sign(number) === 1 || Math.sign(number) === 0 ? "+" : "");

const TimeZoneSearchField: React.FC<TimeZoneSearchFieldProps> = ({
  placeholder = "Timezone",
  name = "",
  nameProp = "name",
  selectedValue,
  onChangeValue,
  clear,
  error = "",
  testID,
}) => {
  const getFullTimeZoneName = (option: any) => `${option.timezone} (UTC${getTimezoneSign(option.offset)}${option.offset})`;

  const options = useRef<ExtraOptionsI>({
    requestOptions: { externalUrl: REACT_APP_BACKEND_COMMON_URL },
  });
  const { data, loading, noMore, setKeyword, getNextPage } = useSearchableData(
    "/timezones",
    "timezone",
    options.current,
  );

  const handleSetKeyword = (_: string, value: string) => setKeyword(value);

  return (
    <Autocomplete
      asycFilter={handleSetKeyword}
      noMore={noMore}
      getMore={getNextPage}
      placeholder={placeholder}
      name={name}
      renderOption={getFullTimeZoneName}
      options={data}
      keyProp="timezone_id"
      nameProp={nameProp}
      selectedValue={selectedValue}
      error={error}
      loading={loading}
      onChangeValue={onChangeValue}
      clear={clear}
      testID={testID}
    />
  );
};

export default TimeZoneSearchField;
